import type { Distance, SpatialRectangle } from "@pdfking/math"
import type { PlotRect } from "@pdfking/renderer-api"
import { PlotFunction } from "@pdfking/renderer-api"

export const CreateRect = (position: SpatialRectangle<Distance>, opts: Partial<PlotRect> = {}) => ({
  enum: PlotFunction.PLOT_RECT as const,
  position,
  ...opts,
})
